import { useEffect, type ReactNode } from 'react';
import { useUiStore } from '@noor/lib';

/**
 * Applies the persisted theme to <html class="dark"> and keeps it in sync.
 * Theme is ephemeral UI state owned by the Zustand store (durable via persist).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUiStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return children;
}
